import React from "react";

import { DefaultButton } from "../../inputs/button/DefaultButton";
import { Stack } from "../../layouts/stack/Stack";
import { Dialog, DialogFooter, DialogType } from "../Dialog";

export interface WarningDialogProps {
    warnings: string[];
    hidden: boolean;
    onDismiss(): void;
}

export const WarningDialog: React.FunctionComponent<WarningDialogProps> = (props: WarningDialogProps) => {
    const handleDismiss = () => {
        props.onDismiss();
    };

    return (
        <Dialog
            hidden={props.hidden}
            onDismiss={handleDismiss}
            dialogContentProps={{
                type: DialogType.normal,
                title: "Warning"
            }}
            modalProps={{ isBlocking: true }}
        >
            <Stack styles={{ root: { paddingBottom: 30 } }}>
                {props.warnings.map((message: string) => {
                    return <Stack key={message}> {message} </Stack>;
                })}
            </Stack>
            <DialogFooter>
                <DefaultButton text="OK" onClick={handleDismiss} />
            </DialogFooter>
        </Dialog>
    );
};
